'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./sections/product-tabs');

require('./sections/video');

require('./sections/header');

require('./sections/footer');

require('./sections/slider-review');

require('./sections/collection');

require('./sections/product-custom');

require('./sections/product-accordion');

require('./layout/jquery.nice-select.min');

require('./sections/slider-process');

require('./templates/reviews');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  if (document.body.clientWidth > 1024) {
    (0, _jquery2.default)('#sort-by').niceSelect();
  }
});